import * as _ from 'underscore';
import * as ng from 'angular';
import * as nggt from 'angular-gettext';
import { SiteConfig } from '../shared';

const languages = _.chain(require('../../../../../langs.json'))
   .map((l:any) => [l.code, l.name])
   .object()
   .value();

class FooterController implements ng.IComponentController {
   static $inject = ['config', '$sce', 'gettextCatalog'];

   // use an array instead of object for languages to control order
   readonly languages:{code:string,name:string}[];

   constructor(
      private config:SiteConfig,
      private $sce:ng.ISCEService,
      private gettextCatalog:nggt.gettextCatalog
   ) {
      this.languages = _.map(this.config.campaign.settings.languages, (code) => {
         return {
            code:code,
            name:languages[code]
         };
      });
   }

   get language() {
      return this.gettextCatalog.getCurrentLanguage();
   }

   get languageName() {
      return languages[this.language];
   }

   get isMultiLanguage() {
      return this.languages.length > 1;
   }

   get footerText():string {
      let footerText:string;
      if (this.config.settings.mirrorCampaignFooter) {
         footerText = this.config.campaign.settings.experienceFooterText[this.language];
      } else if (this.config.settings.footerText[this.language]) {
         footerText = this.config.settings.footerText[this.language];
      }

      if (footerText) {
         return this.$sce.trustAsHtml(footerText);
      }
   }

   get twitterLink() {
      return this.config.campaign.settings.twitterLink;
   }

   get facebookLink() {
      return this.config.campaign.settings.facebookLink;
   }

   get instagramLink() {
      return this.config.campaign.settings.instagramLink;
   }

   get termsUrl() {

      if (this.config.settings.termsURL && this.config.settings.termsURL[this.language]) {
         return this.config.settings.termsURL[this.language];
      }
   }

   get privacyUrl() {
      if (this.config.settings.privacyURL && this.config.settings.privacyURL[this.language]) {
         return this.config.settings.privacyURL[this.language];
      }
   }
   
   get footerHideDefaultLinks() {
      return this.config.settings.footerHideDefaultLinks;
   }
}

ng.module('selfReg').component('footer', {
   templateUrl: require('./footer.html'),
   controller: FooterController
});
